import React from "react";
import { useSlideObserver } from "../../hooks/useSlideObserver";

export const SlideShell = ({
  index,
  total,
  label,
  kicker,
  children,
  onActive,
  bgStyle,
  theme = "br",
  plain = false,
  className = "",
}) => {
  const ref = useSlideObserver({ index, onActive });

  if (theme === "emissor") {
    let slideClass = "emissor-slide reveal";
    if (plain) {
      slideClass += " variant-plain";
    }

    return (
      <section
        ref={ref}
        data-slide-index={index}
        data-testid={`slide-${index + 1}`}
        className={slideClass}
        style={bgStyle}
      >
        <div className="absolute top-[34px] left-[28px] md:left-[86px] z-20 flex flex-col gap-[14px]">
          {label && (
            <div className="font-mono font-bold text-[14px] leading-none tracking-[0.28em] text-white/48 uppercase">
              <b className="text-[var(--gold)] font-extrabold tracking-[0.14em]">
                {String(index + 1).padStart(2, "0")}
              </b>
              <span className="text-white/24 mx-[14px]">/</span>
              {String(total).padStart(2, "0")} - {label}
            </div>
          )}
          {kicker && (
            <>
              <div className="w-full" style={{ height: "2px", backgroundColor: "var(--gold)" }} />
              <div className="font-mono font-bold text-[15px] leading-[1.3] tracking-[0.42em] text-[var(--gold)] uppercase">
                {kicker}
              </div>
            </>
          )}
        </div>
        {children}
      </section>
    );
  }

  if (theme === "ezerp") {
    return (
      <div
        ref={ref}
        data-slide-index={index}
        data-testid={`slide-${index + 1}`}
        style={{ scrollSnapAlign: "start" }}
      >
        {children}
      </div>
    );
  }

  if (theme === "ezerppartners") {
    // Determine if this slide is active by comparing its index with a passed 'active' prop
    // Actually, SlideShell doesn't receive 'active' prop currently. It only emits 'onActive'.
    // Let's pass className down, and we'll apply it. Wait, the original SlideShell doesn't know the active index.
    // Instead of modifying SlideShell to know the active index, I will apply 'active' to the wrapper in EzERPPartnersDeck.
    return (
      <section
        id={`slide-${index + 1}`}
        ref={ref}
        data-slide-index={index}
        data-testid={`slide-${index + 1}`}
        className={`slide ${className || ''}`}
        style={{ scrollSnapAlign: "start", ...bgStyle }}
      >
        {children}
      </section>
    );
  }

  // Default to "br" theme
  return (
    <section
      ref={ref}
      data-slide-index={index}
      data-testid={`slide-${index + 1}`}
      className="slide grain reveal"
      style={bgStyle}
    >
      <div className="absolute top-6 left-6 md:left-12 z-10 flex items-center gap-3 slide-num">
        <span>
          {String(index + 1).padStart(2, "0")}
          <span className="text-[var(--text-muted)]"> / {String(total).padStart(2, "0")}</span>
        </span>
        {label && (
          <>
            <span className="w-8 h-[1px] bg-white/15" />
            <span className="text-[var(--text-muted)]">{label}</span>
          </>
        )}
      </div>
      <div className="w-full h-full pt-14">
        {children}
      </div>
    </section>
  );
};

